// #region imports

// --- Angular
import { Component } from '@angular/core';
import { Router } from '@angular/router';

// #endregion

@Component({
  selector: 'hs-error-notfound',
  templateUrl: './error-notfound.component.html',
  styleUrls: ['./error-notfound.component.scss']
})
export class ErrorNotfoundComponent {

  constructor(private router: Router) { }

  onHomePageClick(): void {
    this.router.navigate(['']);
  }
}


